export const MODULES = {
  students: {
    permission: "students:read",
    route: "students",
  },
  teachers: {
    permission: "teachers:read",
    route: "teachers",
  },
  staff: {
    permission: "staff:read",
    route: "staff",
  },
  inventory: {
    permission: "inventory:read",
    route: "inventory",
  },
  vendor: {
    permission: "vendor:read",
    route: "vendor",
  },
  assets: {
    permission: "assets:read",
    route: "assets",
  },
  feeManagement: {
    permission: "fee-management",
    route: "fee-management",
  },
  announcements: {
    permission: "announcements",
    route: "announcements",
  },
  settings: {
    permission: "settings",
    route: "settings",
  },
  payroll: {
    permission: "payroll",
    route: "payroll",
  },
  faq: {
    permission: "faq",
    route: "faq",
  },
  busRoutes: {
    permission: "bus-routes",
    route: "bus-routes",
  },
  alert: {
    permission: "alert",
    route: "alert",
  },
  classroomMapping: {
    permission: "classroom-mapping",
    route: "classroom-mapping",
  },
  holiday: {
    permission: "holiday",
    route: "holiday",
  },
  classTransition: {
    permission: "class-transition",
    route: "class-transition",
  },
  teacherAttendance: {
    permission: "teacher-attendance",
    route: "teacher-attendance",
  },
  registrationFaces: {
    permission: "registration-faces",
    route: "registration-faces",
  },
  classManagement: {
    permission: "settings-classes",
    route: "class-management",
  },
  customerLedger: {
    permission: "customer-ledger",
    route: "customer-ledger",
  },
};
